import {ReactNode} from 'react'

import {FlexibleLayout} from '@defign/ui'
import classNames from 'classnames/bind'

import styles from './FlexibleBox.module.scss'

const cx = classNames.bind(styles)

export type FlexibleBoxProps = {
    topElement?: ReactNode
    bottomElement?: ReactNode
    isFullHeight?: boolean
    backGroundGrayLevel?: 'WHITE' | 'PALE' | 'LIGHT' | 'REGULAR'
    contentColorType?: 'white' | 'none'
    widthType?: 'wide'
    containerClassName?: string
    innerClassName?: string
}

const BackGroundColorMap: Record<
    Exclude<FlexibleBoxProps['backGroundGrayLevel'], undefined>,
    Parameters<typeof FlexibleLayout>[0]['colorType']
> = {
    WHITE: 'white',
    PALE: 'gray100',
    LIGHT: 'gray150',
    REGULAR: 'gray200',
} as const

const FlexibleBox = ({
    children,
    topElement,
    bottomElement,
    isFullHeight,
    backGroundGrayLevel = 'LIGHT',
    contentColorType,
    widthType,
    containerClassName,
    innerClassName,
}: React.PropsWithChildren<FlexibleBoxProps>) => {
    return (
        <FlexibleLayout
            isFullHeight={isFullHeight}
            colorType={BackGroundColorMap[backGroundGrayLevel]}
            innerClassName={cx({article: bottomElement === undefined}, innerClassName)}
            contentColorType={contentColorType}
            widthType={widthType}
            containerClassName={containerClassName}
            topElement={topElement}
            bottomElement={bottomElement && <div className={cx('section-bottom')}>{bottomElement}</div>}
        >
            {children}
        </FlexibleLayout>
    )
}

export default FlexibleBox
